export enum SharedAssetRequestStatus {
  REQUESTED = 'REQUESTED',
  APPROVED = 'APPROVED',
  DENIED = 'DENIED',
  REVOKED = 'REVOKED',
  DELETED = 'DELETED'
}

export enum SharedAssetsRequestAction {
  APPROVE = 'approve',
  DELETE = 'delete',
  DENY = 'deny'
}

export type K8sClusterAccessRequest = {
  companyId: string
  owningTeamId: string
  createdAt: string
  updatedAt: string
  approver: string
  requester: string
  assetName: string
  currentStatus: SharedAssetRequestStatus
  assetId: string
  sharedTeam: string
  namespace: string
  requestId: string
}

export type NewSharedAssetsRequest = {
  owningTeamId: string
  assetId: string
  namespace: string
  teamToShareWith: string
}

export type SharedAssetsRequestsPayload = {
  newRequests: NewSharedAssetsRequest[]
}

export type SharedAssetsRequestsTeamDefinition = {
  identifier: string
  name: string
  usersCount: number
}

export interface K8sAssetToRequestMap {
  [k: string]: K8sClusterAccessRequest[]
}

export interface K8sIdToTeamMapping {
  [k: string]: SharedAssetsRequestsTeamDefinition
}

export interface SharedAssetsRequestsToMeGetResponse {
  assetToRequestMap: K8sAssetToRequestMap
  idToTeamMapping: K8sIdToTeamMapping
}

export interface SharedAssetsRequestsPostResponse {
  assetToRequestMap: K8sAssetToRequestMap
  idToTeamMapping: K8sIdToTeamMapping
}

export type SharedAssetsRequestsByActionPayload = {
  requestIds: string[]
}
